export function now() {
  return Date.now().valueOf();
}
